import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const ReviewsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_reviews_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_reviews_success", (state,action) => {
        state.isLoading = false;
        state.AllReviews = action.payload.reviews;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_all_reviews_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_reviews_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_reviews_success", (state,action) => {
        state.isLoading = false;
        state.FillterReviews = action.payload.reviews;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_reviews_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_review_request", (state) => {
        state.isLoadingreview = true;
      })
      .addCase("get_review_success", (state,action) => {
        state.isLoadingreview = false;
        state.reviewData = action.payload;
      })
      .addCase("get_review_error", (state,action) => {
        state.isLoadingreview = false;
        state.err = action.payload;
      })
  });
  
  export default ReviewsReducer;